import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllArchivedGroupsUseCaseInterface } from 'domain/usecases';
import { IArchivedGroupsListFilters } from 'presentation/app/modules/Groups/models/archived-groups-list-filters';

interface IArchivedGroupsListState {
  archivedGroupsListData: GetAllArchivedGroupsUseCaseInterface.Result;
  archivedGroupsListFilters: IArchivedGroupsListFilters;
}

interface IPayloadArchivedGroupsListData
  extends PayloadAction<GetAllArchivedGroupsUseCaseInterface.Result> {}

interface IPayloadArchivedGroupsListFilters
  extends PayloadAction<IArchivedGroupsListFilters> {}

const initialState: IArchivedGroupsListState = {
  archivedGroupsListData: null,
  archivedGroupsListFilters: null,
};

export const ArchivedGroupsListSlice = createSlice({
  name: 'archived-groups-list',
  initialState,
  reducers: {
    loadArchivedGroupsListData: (
      state,
      action: IPayloadArchivedGroupsListData,
    ) => {
      state.archivedGroupsListData = action.payload;
    },
    clearArchivedGroupsListData: (state) => {
      state.archivedGroupsListData = null;
    },
    loadArchivedGroupsListFilters: (
      state,
      action: IPayloadArchivedGroupsListFilters,
    ) => {
      state.archivedGroupsListFilters = action.payload;
    },
    clearArchivedGroupsListFilters: (state) => {
      state.archivedGroupsListFilters = null;
    },
  },
});

export const {
  loadArchivedGroupsListData,
  clearArchivedGroupsListData,
  loadArchivedGroupsListFilters,
  clearArchivedGroupsListFilters,
} = ArchivedGroupsListSlice.actions;

export default ArchivedGroupsListSlice.reducer;
